import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Plus, Trash2 } from "lucide-react";

export default function ZonesTab() {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/admin/pricing").then((r) => setCfg(r.data)); }, []);
  if (!cfg) return <div className="text-stone-400"><Loader2 className="w-5 h-5 animate-spin" /></div>;

  const zones = cfg.travel_zones || [];
  const setZone = (i, k, v) => setCfg((c) => ({ ...c, travel_zones: c.travel_zones.map((z, idx) => idx === i ? { ...z, [k]: v } : z) }));
  const addZone = () => setCfg((c) => ({ ...c, travel_zones: [...c.travel_zones, { id: `zone${Date.now()}`, name: "", from: 0, to: 0, surcharge: 0, supported: true }] }));
  const rmZone = (i) => setCfg((c) => ({ ...c, travel_zones: c.travel_zones.filter((_, idx) => idx !== i) }));

  const save = async () => {
    setSaving(true);
    try { const r = await api.put("/admin/pricing", cfg); setCfg(r.data); toast.success("Зоны сохранены"); }
    catch (e) { toast.error("Ошибка сохранения"); }
    finally { setSaving(false); }
  };

  const inputCls = "w-full px-3 py-2 rounded-lg border border-stone-300 text-sm outline-none focus:border-[#1E3A2F]";

  return (
    <div className="space-y-4" data-testid="admin-zones-tab">
      <p className="text-sm text-stone-500">Настройте зону обслуживания по диапазонам почтовых индексов и надбавку за выезд (DKK, с НДС). Снимите галочку «Доступно», чтобы отметить недоступную зону.</p>
      <div className="bg-white border border-stone-200 rounded-2xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-stone-50 text-stone-500 text-xs uppercase">
              <tr>
                <th className="text-left px-4 py-3">Название</th>
                <th className="text-left px-4 py-3">От</th>
                <th className="text-left px-4 py-3">До</th>
                <th className="text-left px-4 py-3">Надбавка</th>
                <th className="text-left px-4 py-3">Доступно</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {zones.map((z, i) => (
                <tr key={i} data-testid={`zone-row-${i}`}>
                  <td className="px-3 py-2"><input className={inputCls} value={z.name} onChange={(e) => setZone(i, "name", e.target.value)} data-testid={`zone-name-${i}`} /></td>
                  <td className="px-3 py-2 w-24"><input type="number" className={inputCls} value={z.from} onChange={(e) => setZone(i, "from", parseInt(e.target.value) || 0)} data-testid={`zone-from-${i}`} /></td>
                  <td className="px-3 py-2 w-24"><input type="number" className={inputCls} value={z.to} onChange={(e) => setZone(i, "to", parseInt(e.target.value) || 0)} data-testid={`zone-to-${i}`} /></td>
                  <td className="px-3 py-2 w-28"><input type="number" step="0.01" className={inputCls} value={z.surcharge} onChange={(e) => setZone(i, "surcharge", parseFloat(e.target.value) || 0)} data-testid={`zone-surcharge-${i}`} /></td>
                  <td className="px-3 py-2 text-center"><input type="checkbox" className="w-4 h-4 accent-[#1E3A2F]" checked={z.supported} onChange={(e) => setZone(i, "supported", e.target.checked)} data-testid={`zone-supported-${i}`} /></td>
                  <td className="px-3 py-2"><button onClick={() => rmZone(i)} className="text-stone-400 hover:text-red-600" data-testid={`zone-remove-${i}`}><Trash2 className="w-4 h-4" /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex gap-3">
        <button onClick={addZone} className="inline-flex items-center gap-2 text-sm font-semibold text-[#1E3A2F]" data-testid="zone-add-btn"><Plus className="w-4 h-4" /> Добавить зону</button>
      </div>
      <button onClick={save} disabled={saving} className="px-6 py-3 rounded-full bg-[#1E3A2F] text-white font-semibold disabled:opacity-60" data-testid="zones-save-btn">
        {saving ? "Сохранение…" : "Сохранить зоны"}
      </button>
    </div>
  );
}
